import { render, staticRenderFns } from "./technical-support.vue?vue&type=template&id=08d9d481&scoped=true"
import script from "./technical-support.vue?vue&type=script&lang=js"
export * from "./technical-support.vue?vue&type=script&lang=js"
import style0 from "./technical-support.vue?vue&type=style&index=0&id=08d9d481&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d9d481",
  null
  
)

export default component.exports